import AndroidIcon from '@listening/assets/astro/icons/android.svg?react';
import AppleIcon from '@listening/assets/astro/icons/apple.svg?react';
import ChromeExtIcon from '@listening/assets/astro/icons/chrome-ext.svg?react';
import { Button } from '@listening/frontend/components/radix/button';
import { Computer, Globe } from 'iconoir-react';
import type { ReactNode } from 'react';
import { clientEnv } from '@/env';
import * as m from '@/paraglide/messages';
import { localizeHref } from '@/paraglide/runtime';

function PlatformLink({
  href,
  label,
  children,
}: {
  href: string;
  label: string;
  children: ReactNode;
}) {
  return (
    <Button
      asChild
      variant='ghost'
      className='h-auto w-30 flex-col gap-3 rounded-xl px-2 py-4 font-normal text-(--pricing-ink) hover:bg-(--pricing-blue-pale)'
    >
      <a href={href}>
        <span
          aria-hidden='true'
          className='flex size-8 items-center justify-center [&_svg]:h-7 [&_svg]:w-7'
        >
          {children}
        </span>
        <span className='text-center text-[13px] whitespace-nowrap'>
          {label}
        </span>
      </a>
    </Button>
  );
}

export function PricingPlatforms() {
  return (
    <section
      aria-labelledby='platforms-title'
      className='border-t border-(--pricing-border)/50 px-5 py-10 min-[641px]:px-8 min-[641px]:py-12'
    >
      <div className='mx-auto max-w-240 text-center'>
        <h2
          id='platforms-title'
          className='text-[22px] font-semibold tracking-[-0.5px] text-balance min-[641px]:text-[27px]'
        >
          {m.pricing_platforms_title()}
        </h2>
        <div className='mt-6 flex flex-wrap justify-center gap-x-2 gap-y-1 min-[641px]:gap-x-5'>
          <PlatformLink
            href='https://play.google.com/store/apps/details?id=io.listening.main'
            label={m.funnel_device_android()}
          >
            <AndroidIcon />
          </PlatformLink>
          <PlatformLink
            href='https://apps.apple.com/us/app/listening-read-on-the-go/id1635430768'
            label={m.pricing_platform_ios()}
          >
            <AppleIcon />
          </PlatformLink>
          <PlatformLink
            href={localizeHref('/app/home')}
            label={m.funnel_device_web()}
          >
            <Globe strokeWidth={1.5} />
          </PlatformLink>
          <PlatformLink
            href='https://chromewebstore.google.com/detail/listeningcom/amjjglmomeodglgclcnjdjbhhcfnbnpd'
            label={m.pricing_platform_extension()}
          >
            <ChromeExtIcon />
          </PlatformLink>
          {clientEnv.desktopDownloadsEnabled && (
            <PlatformLink href='/download' label={m.pricing_platform_desktop()}>
              <Computer strokeWidth={1.5} />
            </PlatformLink>
          )}
        </div>
      </div>
    </section>
  );
}
